<template>
    <div class="backdrop backdrop-search">
        <div class="shop-modal modal-search">
            <div class="modal-inner modal-search-top-selector">
                <div class="search-form-wrapper">
                    <form
                        class="form-group search-input-group"
                        :action="'/' + __('frontend_js.routes.search-result')"
                        id="main-searchbar"
                    >
                        <div class="input-group">
                            <input
                                type="text"
                                name="q"
                                class="form-control search-input"
                                id="mainPageSearch"
                                :placeholder="__('frontend_js.layout.search-placeholder')"
                                aria-describedby="inputGroupPrepend"
                                required
                                autocomplete="off"
                                @input="searchTimeOut"
                                v-model="search"
                            />
                        </div>
                    </form>
                    <div v-if="loading" class="spinnerWrapper">
                        <span v-if="gant == true">
                            <spinner-gant data-spinner />
                        </span>
                        <span v-else>
                            <spinner-vermont data-spinner />
                        </span>
                    </div>
                    <button class="small-icons search2-icon" type="submit" form="main-searchbar"></button>
                    <div v-if="searchResultData" class="suggest-results-wrapper row mx-0 flex-wrap-reverse flex-md-wrap">
                        <div
                            v-if="categories.length > 0 || articles.length > 0 || stores.length > 0"
                            class="pages col-12 col-md-4 col-lg-3"
                        >
                            <div v-if="categories.length > 0" class="suggest-result">
                                <h3>{{ __('frontend_js.search.categories') }}</h3>
                                <ul>
                                    <li v-for="category in categories" :key="category.category_id">
                                        <a :href="category.slug" class="hover-remove-underline">
                                            {{ category.name }}
                                            <!-- <span style="color: gray"
                                                >({{ category.category.parent_categories[0].translations[0].title }})</span
                                            > -->
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div v-if="articles.length > 0" class="suggest-result">
                                <h3>{{ __('frontend_js.search.articles') }}</h3>
                                <ul>
                                    <li v-for="article in articles" :key="article.id">
                                        <a :href="article.slug" class="hover-remove-underline">{{ article.title }} </a>
                                    </li>
                                </ul>
                            </div>
                            <div v-if="stores.length > 0" class="suggest-result">
                                <h3>{{ __('frontend_js.search.stores') }}</h3>
                                <ul>
                                    <li v-for="store in stores" :key="store.id">
                                        <a :href="store.slug" class="hover-remove-underline">{{ store.title }} </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="coloredProducts coloredProducts--search col-12 col-md-8 col-lg-9">
                            <search-product-list
                                :items-from-view="coloredProducts"
                                :vermont="vermont"
                                :gant="gant"
                                :key="renderKey"
                            >
                            </search-product-list>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        gant: { type: Boolean },
        vermont: { type: Boolean },
        authCheck: { type: Boolean },
    },
    data() {
        return {
            search: '',
            coloredProducts: [],
            categories: [],
            articles: [],
            blogs: [],
            stores: [],
            renderKey: 0,
            loading: false,
            timer: null,
        };
    },
    computed: {
        searchResultData() {
            return (this.stores.length > 0) |
                (this.articles.length > 0) |
                (this.categories.length > 0) |
                (this.coloredProducts.length > 0)
                ? true
                : false;
        },
        url() {
            if (this.authCheck == true) return '/main-search/fetch-auth';
            else return '/main-search/fetch';
        },
    },
    watch: {},
    methods: {
        searchTimeOut() {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.fetchSearchResult();
            }, 800);
        },
        fetchSearchResult() {
            this.loading = true;
            this.$http
                .request({
                    method: 'POST',
                    url: this.url,
                    data: {
                        search: this.search,
                    },
                })
                .then(res => {
                    let data = res.data;
                    if (data.coloredProducts) {
                        this.coloredProducts = data.coloredProducts;
                    }
                    if (data.categories) {
                        this.categories = data.categories;
                    }
                    if (data.articles) {
                        this.articles = data.articles;
                    }
                    if (data.stores) {
                        this.stores = data.stores;
                    }
                    this.renderKey++;
                })
                .catch(e => {
                    console.log(e);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
